import { Injectable } from '@angular/core';
import { TutorDialogTxt, UserActionType } from 'models';

@Injectable({
  providedIn: 'root'
})
export class TutorDialogTxtsService {

    static Finale(nResult: number): TutorDialogTxt {
        return {
            data: {
                title: 'TUTOR - QUESTIONARIO',
                content: [
                    {
                        typo: 'str',
                        str: `Il numero di prodotti assicurativi che soddisfano le tue risposte è elevato, pari a ${nResult}, ed è quindi opportuno che riconsideri le risposte meno filtranti: `
                    },
                    {
                        typo: 'click',
                        str: 'clicca qui',
                        value: 1
                    },
                    {
                        typo: 'str',
                        str: ' per procedere a ritroso in modo guidato.'
                    },
                    { typo: 'break' }, { typo: 'break' },
                    {
                        typo: 'str',
                        str: 'Oppure puoi '
                    },
                    {
                        typo: 'click',
                        str: 'tornare indietro in autonomia',
                        value: 2
                    },
                    {
                        typo: 'str',
                        str: ' cliccando sulle barre blu orizzontali relative alle risposte che hai già fornito, o sulle sezioni numerate da 1 a 3 nella barra di completamento in alto, per valutare cambiamenti alle tue risposte'
                    }
                ],
                type: 'tutor'
            },
            uav: [
                {
                    value: 1,
                    action: { type: UserActionType.activateTutor, isManual: false }
                },
                {
                    value: 2,
                    action: { type: UserActionType.activateTutor, isManual: true }
                },
            ]
        }
    }

    static Ok(nResult): TutorDialogTxt {
        return {
            data: {
                title: 'TUTOR - QUESTIONARIO',
                content: [
                    {
                        typo: 'str',
                        str: `Il numero di prodotti assicurativi che soddisfano le tue risposte, pari a ${nResult}, ricade in un intervallo ottimale: `
                    },
                    {
                        typo: 'click',
                        str: 'clicca qui',
                        value: 1
                    },
                    {
                        typo: 'str',
                        str: ' per visualizzare il risultato della ricerca.'
                    },
                    { typo: 'break' }, { typo: 'break' },
                    {
                        typo: 'str',
                        str: 'Potrai sempre tornare indietro in autonomia cliccando sulle sezioni numerate da 1 a 3 nella barra di completamento in alto, se intenderai valutare qualche cambiamento alle tue risposte.'
                    },
                    { typo: 'break' }, { typo: 'break' },
                    {
                        typo: 'click',
                        str: 'Chiudi e continua',
                        value: 0
                    },
                ],
                type: 'tutor'
            },
            uav: [
                {
                    value: 0,
                    action: { type: UserActionType.deactivateTutor }
                },
                {
                    value: 1,
                    action: { type: UserActionType.startSearch }
                },
            ]
        }
    }

    static Pochi(nResult): TutorDialogTxt {
        return {
            data: {
                title: 'TUTOR - QUESTIONARIO',
                content: [
                    {
                        typo: 'str',
                        str: `Le tue risposte hanno filtrato un gran numero di prodotti assicurativi e solo ${nResult} soddisfano le tue scelte: puoi `
                    },
                    {
                        typo: 'click',
                        str: 'visualizzarli nel risultato della ricerca',
                        value: 0
                    },
                    {
                        typo: 'str',
                        str: ', oppure '
                    },
                    {
                        typo: 'click',
                        str: 'clicca qui',
                        value: 1
                    },
                    {
                        typo: 'str',
                        str: ' se vuoi riconsiderare a ritroso, in modo guidato, una o più risposte che hanno filtrato in misura maggiore.'
                    },
                    { typo: 'break' }, { typo: 'break' },
                    {
                        typo: 'str',
                        str: 'Potrai anche tornare indietro in autonomia, '
                    },
                    {
                        typo: 'click',
                        str: 'adesso',
                        value: 2
                    },
                    {
                        typo: 'str',
                        str: ' o dopo aver visualizzato i prodotti risultanti, cliccando sulle sezioni numerate da 1 a 3 nella barra di completamento in alto per valutare eventuali cambiamenti alle tue risposte.'
                    },
                ],
                type: 'tutor'
            },
            uav: [
                {
                    value: 0,
                    action: { type: UserActionType.startSearch }
                },
                {
                    value: 1,
                    action: { type: UserActionType.activateTutor, isManual: false }
                },
                {
                    value: 2,
                    action: { type: UserActionType.activateTutor, isManual: true }
                },
            ]
        }
    }

    static Tanti(nResult): TutorDialogTxt {
        return {
            data: {
                title: 'TUTOR - QUESTIONARIO',
                content: [
                    {
                        typo: 'str',
                        str: `Il numero di prodotti assicurativi che soddisfano le tue risposte è ancora piuttosto elevato, pari a ${nResult}: `
                    },
                    {
                        typo: 'click',
                        str: 'clicca qui',
                        value: 0
                    },
                    {
                        typo: 'str',
                        str: ' per visualizzare comunque il risultato della ricerca.'
                    },
                    { typo: 'break' }, { typo: 'break' },
                    {
                        typo: 'str',
                        str: 'Oppure puoi '
                    },
                    {
                        typo: 'click',
                        str: 'tornare indietro in autonomia',
                        value: 1
                    },
                    {
                        typo: 'str',
                        str: 'cliccando sulle barre blu orizzontali relative alle risposte che hai già fornito, o sulle sezioni numerate da 1 a 3 nella barra di completamento in alto, se intendi valutare qualche cambiamento alle tue risposte. '
                    },
                ],
                type: 'tutor'
            },
            uav: [
                {
                    value: 0,
                    action: { type: UserActionType.startSearch }
                },
                {
                    value: 1,
                    action: { type: UserActionType.deactivateTutor }
                },
            ]
        }
    }

    static Risultato(): TutorDialogTxt {
        return {
            data: {
                title: 'TUTOR - QUESTIONARIO',
                content: [
                    {
                        typo: 'str',
                        str: 'La ricerca e comparazione che stai chiudendo non è stata ancora salvata: '
                    },
                    {
                        typo: 'click',
                        str: 'clicca qui',
                        value: 1
                    },
                    {
                        typo: 'str',
                        str: 'o in alto sul dischetto per salvarla; potrai riaprirla quando vuoi cliccando sulla voce Ricerche che trovi in testa alla pagina.'
                    },
                    { typo: 'break' }, { typo: 'break' },
                    {
                        typo: 'str',
                        str: 'Diversamente, '
                    },
                    {
                        typo: 'click',
                        str: 'chiudi questo suggerimento',
                        value: 1
                    },
                    {
                        typo: 'str',
                        str: '.'
                    },
                ],
                type: 'tutor'
            },
            uav: [
                {
                    value: 0,
                    action: { type: UserActionType.ignore }
                },
                {
                    value: 1,
                    action: { type: UserActionType.ignore }
                },
            ]
        }
    }

    static Dettaglio(): TutorDialogTxt {
        return {
            data: {
                title: 'TUTOR - QUESTIONARIO',
                content: [
                    {
                        typo: 'str',
                        str: 'La pagina di dettaglio prodotto che stai chiudendo non è stata salvata: '
                    },
                    {
                        typo: 'click',
                        str: 'clicca qui',
                        value: 1
                    },
                    {
                        typo: 'str',
                        str: 'o in alto sul dischetto se desideri salvarla, in modo da inserire il prodotto tra i tuoi preferiti; potrai riaprirlo agevolmente quando vuoi cliccando sulla voce Preferiti che trovi in testa alla pagina.'
                    },
                    { typo: 'break' }, { typo: 'break' },
                    {
                        typo: 'str',
                        str: 'Diversamente, '
                    },
                    {
                        typo: 'click',
                        str: 'chiudi questo suggerimento',
                        value: 1
                    },
                    {
                        typo: 'str',
                        str: '.'
                    },
                ],
                type: 'tutor'
            },
            uav: [
                {
                    value: 0,
                    action: { type: UserActionType.ignore }
                },
                {
                    value: 1,
                    action: { type: UserActionType.ignore }
                },
            ]
        }
    }

}
